import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import React from "react";
import Home from "./Pages/Home";
import AppBar from "./Components/AppBar";
import About from "./Pages/About";
import Contact from "./Pages/Contact";
import Footer from "./Components/Footer";
import NodeJs from "./Pages/NodeJs";
import ReactJs from "./Pages/ReactJs";
import MobileApplication from "./Pages/MobileApplication";
import WebDevelopment from "./Pages/WebDevelopment";
import Ecommerce from "./Pages/Ecommerce";
import Java from "./Pages/Java";
import EnterpriseAppDevelopment from "./Pages/EnterpriseAppDevelopment";
import AlServices from "./Pages/AlServices";
import DigitalMarketing from "./Pages/DigitalMarketing";
import ItConsulting from "./Pages/ItConsulting";
import CloudServicesManagement from "./Pages/CloudServicesManagement";
import SolutionsDesign from "./Pages/SolutionsDesign";
import Insights from "./Pages/Insights";
import Blog from "./Pages/Blog";

function App() {
  return (
    <Router>
      <AppBar />

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/home" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/nodejs" element={<NodeJs />} />
        <Route path="/reactjs" element={<ReactJs />} />
        <Route path="/mobileapplication" element={<MobileApplication />} />
        <Route path="/webdevelopment" element={<WebDevelopment />} />
        <Route path="/ecommerce" element={<Ecommerce />} />
        <Route path="/java" element={<Java />} />
        <Route path="/alservices" element={<AlServices />} />
        <Route
          path="/enterpriseappdevelopment"
          element={<EnterpriseAppDevelopment />}
        />
        <Route path="/digitalmarketing" element={<DigitalMarketing />} />
        <Route path="/itconsulting" element={<ItConsulting />} />
        <Route
          path="/cloudservicesmanagement"
          element={<CloudServicesManagement />}
        />
        <Route path="/solutionsdesign" element={<SolutionsDesign />} />
        <Route path="/insights" element={<Insights />} />
        <Route path="/post/:id" element={<Blog />} />
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;
